import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, concatMap, map} from 'rxjs/operators';
import {of} from 'rxjs';
import * as SynchronizationActions from './synchronization.actions';
import {errorHappened, successHappened} from '../app.types';
import {SynchronizationClientService} from './synchronization-client.service';
import {SynchronizationConfiguration} from './synchronization.reducer';

@Injectable()
export class SynchronizationEffects {

  loadSynchronizations$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SynchronizationActions.loadSynchronizationConfigurations),
      concatMap(() =>
        this.client.fetchConfigurations()
          .pipe(
            map(data => SynchronizationActions.loadSynchronizationsSuccess({configs: data})),
          )),
      catchError(err => of(errorHappened({error: {message: err.message}})))
    );
  });
  loadTaskHistories$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SynchronizationActions.loadTaskHistory),
      concatMap((ev) =>
        this.client.fetchTaskHistories(ev.configId)
          .pipe(
            map(data => SynchronizationActions.loadTaskHistorySuccess({histories: data, configId: ev.configId})),
          )),
      catchError(err => of(errorHappened({error: {message: err.message}}))));
  });
  scheduleSynchronization$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SynchronizationActions.scheduleSynchronization),
      concatMap((ev) => this.client.scheduleSynchronization(ev.configId)),
      map(data => successHappened({
        message: `Synchronization successfully scheduled. 
              Please check back in couple of minutes for the result.`
      })),
      catchError(err => of(errorHappened({error: {message: err.message}}))));
  });

  createSynchronizationConfiguration$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SynchronizationActions.createSynchronizationConfiguration),
      concatMap((ev) =>
        this.client.createNewConfiguration(ev.body as SynchronizationConfiguration)
          .pipe(
            map(data => successHappened({
              message: `Synchronization successfully created.`
            })),
          )),
      catchError(err => of(errorHappened({error: {message: err.message}}))));
  });


  constructor(private actions$: Actions,
              private client: SynchronizationClientService) {
  }
}
